import I18n from 'I18n';
import { checkPermissions } from './permissions';
export function getActionModalOrPanel(actions, id) {
  const currentAction = actions.find(action => action.id === id);
  if (!currentAction) {
    return undefined;
  }
  return currentAction.ModalOrPanel;
}
export function getActionOnConfirm(actions, id) {
  const currentAction = actions.find(action => action.id === id);
  if (!currentAction) {
    return undefined;
  }
  return currentAction.onConfirm;
}
export function groupActions({
  actions,
  crmObject,
  gates,
  layoutUse,
  nonCrmObject,
  scopes
}) {
  const uniqueGroupIds = Array.from(new Set(actions.map(({
    actionGroup
  }) => {
    if (typeof actionGroup === 'function') {
      return actionGroup({
        crmObject,
        layoutUse,
        nonCrmObject
      });
    }
    return actionGroup || 0;
  })));
  return uniqueGroupIds.sort((a, b) => a - b).map(groupId => {
    return actions.filter(action => {
      if (typeof action.actionGroup === 'function') {
        return action.actionGroup({
          crmObject,
          layoutUse,
          nonCrmObject
        }) === groupId;
      }
      return action.actionGroup === groupId;
    }).filter(action =>
    /**
     * Remove actions that could be hidden due to gates, scopes
     * or custom implementation before rendering
     */
    checkPermissions({
      permissions: action.displayPermissions,
      scopes,
      gates,
      crmObject,
      nonCrmObject
    })).sort((a, b) => {
      if (a.orderInActionGroup === undefined) {
        return 1;
      }
      if (b.orderInActionGroup === undefined) {
        return -1;
      }
      const orderA = typeof a.orderInActionGroup === 'function' ? a.orderInActionGroup({
        crmObject,
        layoutUse,
        nonCrmObject
      }) : a.orderInActionGroup;
      const orderB = typeof b.orderInActionGroup === 'function' ? b.orderInActionGroup({
        crmObject,
        layoutUse,
        nonCrmObject
      }) : b.orderInActionGroup;
      return orderA - orderB;
    });
  }).filter(group => group.length > 0);
}
export function mergeActionOverrides({
  actionsConfig,
  actionsConfigOverrides = []
}) {
  const actionsConfigIds = actionsConfig.map(({
    id
  }) => id);
  const extraActions = actionsConfigOverrides.filter(actionOverride => !actionsConfigIds.includes(actionOverride.id)).map(action => {
    if (action.name) {
      return action;
    }
    return Object.assign({}, action, {
      name: I18n.text('assetActionsLib.unamedAction')
    });
  });
  const overridenActions = actionsConfig.map(action => {
    const override = actionsConfigOverrides.find(({
      id
    }) => id === action.id) || {};
    return Object.assign({}, action, override);
  });
  return [...overridenActions, ...extraActions];
}